export const NavMenuActionType = {
    TOGGLE_NAV_MENU: "TOGGLE_NAV_MENU",
};

interface IToggleNavMenu {
    type: typeof NavMenuActionType.TOGGLE_NAV_MENU,
}

export type INavMenuActions = IToggleNavMenu

export class NavMenuActions {
    public static toggleNavMenu(): NavMenuActions {
        return {
            type: NavMenuActionType.TOGGLE_NAV_MENU,
        }
    }
}

